import {useEffect, useState} from 'react'
import { Link } from 'react-router-dom';
import logoTitle from '../../assets/images/logo-s.png';
import AnimatedLetters from '../AnimatedLetters/index.js';
import Logo from './Logo';
import './index.scss';
import Loader from 'react-loaders';
const Home = () => {
  const [letterClass, setLetterClass] = useState('text-animate')
  const nameArray = ['a','a','d'];
  const jobArray = ['w','e','b',' ','d','e','v','e','l','o','p','e','r','.']

  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover');
    }, 4000)
  }, []);

  
  return (
    <>
    <div className="container home-page">
      <div className="text-zone">
        <h1>
          <span className={letterClass}>H</span>
          <span className={`${letterClass} _12`}>i</span>
          <br />
          <span className={`${letterClass} _13`}>I</span>
          <span className={`${letterClass} _14`}>'m</span>
        <img src = {logoTitle} alt="developer" /> 
        <AnimatedLetters letterClass={letterClass} strArray={nameArray} idx={15} />
        <br />
        <AnimatedLetters letterClass={letterClass} strArray={jobArray} idx={22} />
        </h1>
        <h2>
          Frontend Developer / Python Expert
        </h2>
        <Link to="/contact" className="flat-button" >CONTACT ME</Link>
        <Link to="/contact" className="flat-button" > CV</Link>
      </div>
      <Logo />
    </div>
    
      <Loader type="pacman" />
    </>
  )
}

export default Home;